module.exports = __webpack_public_path__ + "media/images/real-ilum-2-b8e821c79e78ddf356a7d54d2bf4ff47.png";